/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.0.1
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GeocodingGeoJSONPropertiesAddendum } from "./GeocodingGeoJSONPropertiesAddendum";
import {
  GeocodingGeoJSONPropertiesAddendumFromJSON,
  GeocodingGeoJSONPropertiesAddendumFromJSONTyped,
  GeocodingGeoJSONPropertiesAddendumToJSON,
  GeocodingGeoJSONPropertiesAddendumToJSONTyped,
} from "./GeocodingGeoJSONPropertiesAddendum";

/**
 *
 * @export
 * @interface GeocodingGeoJSONProperties
 */
export interface GeocodingGeoJSONProperties {
  [key: string]: any | any;
  /**
   * A scoped GID for this result. This can be passed to the place endpoint. Note that these are not always stable long-term.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  gid?: string;
  /**
   * An ID referencing the original data source (specified via source) for the result. These IDs are specific to the source that they originated from. For example, in the case of OSM, these typically look like way/123 or point/123.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  sourceId?: string;
  /**
   * A full, human-readable label. However, you may not necessarily want to use this; be sure to read the docs for name, locality, and region before making a decision. This field is mostly localized. The order of components is generally locally correct (ex: for an address in South Korea, the house number appears after the street name). However, components will use a request language equivalent if one exists (ex: Seoul instead of 서울 if lang=en).
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  label?: string;
  /**
   * The data layer containing the place (e.g. "address" or "venue").
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  layer?: string;
  /**
   * The ID of the data source that the result came from.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  source?: string;
  /**
   * The name of the place, the street address including house number, or label of similar relevance. If your app is localized to a specific region, you may get better display results by combining name, locality OR region (or neither?), and postal code together in the local format. Experiment with what works best for your use case.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  name?: string;
  /**
   * The accuracy of the geographic coordinates in the result. This value is a property of the result itself and won't change based on the query.
   * A point result means that the record can reasonably be represented by a single geographic point. Addresses, venues, or interpolated addresses usually have point accuracy.
   * Larger areas, such as a city or country, cannot be represented by a single point, so a centroid is given instead.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  accuracy?: GeocodingGeoJSONPropertiesAccuracyEnum;
  /**
   *
   * @type {GeocodingGeoJSONPropertiesAddendum}
   * @memberof GeocodingGeoJSONProperties
   */
  addendum?: GeocodingGeoJSONPropertiesAddendum;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  continent?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  continentGid?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  country?: string;
  /**
   * The ISO 3166-1 alpha-3 code for the country the place is located in.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  countryA?: string;
  /**
   * The ISO 3166-1 alpha-2 code for the country the place is located in.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  countryCode?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  countryGid?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  neighbourhood?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  neighbourhoodGid?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  borough?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  boroughGid?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  postalcode?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  street?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  housenumber?: string;
  /**
   * The city, village, town, etc. that the place / address is part of. Note that values may not always match postal or local conventions perfectly.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  locality?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  localityGid?: string;
  /**
   * Administrative divisions between localities and regions. Useful for disambiguating nearby results with similar names.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  county?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  countyGid?: string;
  /**
   * Typically the first administrative division within a country. For example, a US state or a Canadian province.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  region?: string;
  /**
   * The abbreviation for the region (e.g. PA for the US state of Pennsylvania).
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  regionA?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  regionGid?: string;
  /**
   * In many countries, this is the lowest level of government. Sometimes interchangeable with locality.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  localadmin?: string;
  /**
   *
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  localadminGid?: string;
  /**
   * For search and structured search results, the type of match.
   * @type {string}
   * @memberof GeocodingGeoJSONProperties
   */
  matchType?: GeocodingGeoJSONPropertiesMatchTypeEnum;
  /**
   * The level of confidence that the result matches what the user searched for. Only available on forward geocoding endpoints.
   * @type {number}
   * @memberof GeocodingGeoJSONProperties
   */
  confidence?: number;
}

/**
 * @export
 */
export const GeocodingGeoJSONPropertiesAccuracyEnum = {
  Point: "point",
  Centroid: "centroid",
} as const;
export type GeocodingGeoJSONPropertiesAccuracyEnum =
  (typeof GeocodingGeoJSONPropertiesAccuracyEnum)[keyof typeof GeocodingGeoJSONPropertiesAccuracyEnum];

/**
 * @export
 */
export const GeocodingGeoJSONPropertiesMatchTypeEnum = {
  Exact: "exact",
  Interpolated: "interpolated",
  Fallback: "fallback",
} as const;
export type GeocodingGeoJSONPropertiesMatchTypeEnum =
  (typeof GeocodingGeoJSONPropertiesMatchTypeEnum)[keyof typeof GeocodingGeoJSONPropertiesMatchTypeEnum];

/**
 * Check if a given object implements the GeocodingGeoJSONProperties interface.
 */
export function instanceOfGeocodingGeoJSONProperties(
  value: object,
): value is GeocodingGeoJSONProperties {
  return true;
}

export function GeocodingGeoJSONPropertiesFromJSON(
  json: any,
): GeocodingGeoJSONProperties {
  return GeocodingGeoJSONPropertiesFromJSONTyped(json, false);
}

export function GeocodingGeoJSONPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeocodingGeoJSONProperties {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    gid: json["gid"] == null ? undefined : json["gid"],
    sourceId: json["source_id"] == null ? undefined : json["source_id"],
    label: json["label"] == null ? undefined : json["label"],
    layer: json["layer"] == null ? undefined : json["layer"],
    source: json["source"] == null ? undefined : json["source"],
    name: json["name"] == null ? undefined : json["name"],
    accuracy: json["accuracy"] == null ? undefined : json["accuracy"],
    addendum:
      json["addendum"] == null
        ? undefined
        : GeocodingGeoJSONPropertiesAddendumFromJSON(json["addendum"]),
    continent: json["continent"] == null ? undefined : json["continent"],
    continentGid:
      json["continent_gid"] == null ? undefined : json["continent_gid"],
    country: json["country"] == null ? undefined : json["country"],
    countryA: json["country_a"] == null ? undefined : json["country_a"],
    countryCode:
      json["country_code"] == null ? undefined : json["country_code"],
    countryGid: json["country_gid"] == null ? undefined : json["country_gid"],
    neighbourhood:
      json["neighbourhood"] == null ? undefined : json["neighbourhood"],
    neighbourhoodGid:
      json["neighbourhood_gid"] == null ? undefined : json["neighbourhood_gid"],
    borough: json["borough"] == null ? undefined : json["borough"],
    boroughGid: json["borough_gid"] == null ? undefined : json["borough_gid"],
    postalcode: json["postalcode"] == null ? undefined : json["postalcode"],
    street: json["street"] == null ? undefined : json["street"],
    housenumber: json["housenumber"] == null ? undefined : json["housenumber"],
    locality: json["locality"] == null ? undefined : json["locality"],
    localityGid:
      json["locality_gid"] == null ? undefined : json["locality_gid"],
    county: json["county"] == null ? undefined : json["county"],
    countyGid: json["county_gid"] == null ? undefined : json["county_gid"],
    region: json["region"] == null ? undefined : json["region"],
    regionA: json["region_a"] == null ? undefined : json["region_a"],
    regionGid: json["region_gid"] == null ? undefined : json["region_gid"],
    localadmin: json["localadmin"] == null ? undefined : json["localadmin"],
    localadminGid:
      json["localadmin_gid"] == null ? undefined : json["localadmin_gid"],
    matchType: json["match_type"] == null ? undefined : json["match_type"],
    confidence: json["confidence"] == null ? undefined : json["confidence"],
  };
}

export function GeocodingGeoJSONPropertiesToJSON(
  json: any,
): GeocodingGeoJSONProperties {
  return GeocodingGeoJSONPropertiesToJSONTyped(json, false);
}

export function GeocodingGeoJSONPropertiesToJSONTyped(
  value?: GeocodingGeoJSONProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ...value,
    gid: value["gid"],
    source_id: value["sourceId"],
    label: value["label"],
    layer: value["layer"],
    source: value["source"],
    name: value["name"],
    accuracy: value["accuracy"],
    addendum: GeocodingGeoJSONPropertiesAddendumToJSON(value["addendum"]),
    continent: value["continent"],
    continent_gid: value["continentGid"],
    country: value["country"],
    country_a: value["countryA"],
    country_code: value["countryCode"],
    country_gid: value["countryGid"],
    neighbourhood: value["neighbourhood"],
    neighbourhood_gid: value["neighbourhoodGid"],
    borough: value["borough"],
    borough_gid: value["boroughGid"],
    postalcode: value["postalcode"],
    street: value["street"],
    housenumber: value["housenumber"],
    locality: value["locality"],
    locality_gid: value["localityGid"],
    county: value["county"],
    county_gid: value["countyGid"],
    region: value["region"],
    region_a: value["regionA"],
    region_gid: value["regionGid"],
    localadmin: value["localadmin"],
    localadmin_gid: value["localadminGid"],
    match_type: value["matchType"],
    confidence: value["confidence"],
  };
}
